<template>
    <div id="page">
        <a v-if="disabled" class="disabled item">
            {{ page }}
        </a>
        <div v-else-if="activated_page" class="active item">{{ page }}</div>
        <a v-else-if="inside_window" class="item" @click="change_page">{{ page }}</a>
        <a v-else-if="truncated" class="disabled item" style="height: 40px;">
            <div v-if="jump_mode" class="ui input">
                <input type="text"
                    placeholder="Jump to ..."
                    @blur="close_jump_input()"
                    @keypress.enter="jump_to()"
                    ref="jump_input"
                    v-model="jump_target"
                    style="width: 90px;">
            </div>
            <i v-else class="ellipsis horizontal icon" @click="open_jump_input()" style="cursor: pointer;"></i>
        </a>
    </div>
</template>

<script>
export default {
    name: "PaginationPage",
    props: {
        page: Number,
        current_page: Number,
        total_pages: Number,
        // limit: Number
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            jump_mode: false,
            jump_target: null
        }
    },
    mounted() {
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        limit() {
            return (this.style.width > 767) ? 3 : 2
        },
        activated_page() {
            return this.page == this.current_page
        },
        inside_window() {
            // 固定左右bound距離
            if (Math.abs(this.current_page - this.page) < this.limit) {
                return true
            }
        },
        truncated() {
            // 固定左右bound距離
            if (Math.abs(this.current_page - this.page) == (this.limit+1)) {
                return true
            }
        }
    },
    methods: {
        open_jump_input() {
            this.jump_mode = true
            this.$nextTick(() => this.$refs.jump_input.focus())
        },
        close_jump_input() {
            this.jump_mode = false
            this.jump_target = null
        },
        jump_to() {
            var page = (this.total_pages <= this.jump_target)
                ? this.total_pages
                : (this.jump_target <= 0 ) ? 1 : this.jump_target

            this.$parent.change_page(page)
        },
        change_page() {
            this.$parent.change_page(this.page)
        }
    },
    components: {
    }
}
</script>

<style scoped>
</style>
